// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mainContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  padding: 1rem;
  background: linear-gradient(to bottom, transparent, #ebebec);
}

.styledReceipt {
  background-color: #fff;
  width: 22rem;
  position: relative;
  padding: 1rem;
  text-align: center;
  box-shadow: 0 -0.4rem 1rem -0.4rem rgba(0, 0, 0, 0.2);
}

.titleReceipt {
  font-size: 1.1rem;
  font-weight: bold;
  padding: 0.5rem 0;
}

.hr {
  border: none;
  border-top: 1px dotted #005B96;
  color: #fff;
  background-color: #fff;
  height: 1px;
  width: 95%;
}

.rowReceipt {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem;
}
.rowReceipt > :first-child {
  font-size: 0.8rem;
}
.rowReceipt > :last-child {
  font-size: 0.875rem;
  font-weight: bold;
}

.styledReceipt::after {
  background-image: linear-gradient(135deg, #fff 0.5rem, transparent 0), linear-gradient(-135deg, #fff 0.5rem, transparent 0);
  background-position: left bottom;
  background-repeat: repeat-x;
  background-size: 1rem;
  content: "";
  display: block;
  position: absolute;
  bottom: -1rem;
  left: 0;
  width: 100%;
  height: 1rem;
}

.unit {
  font-size: 0.5rem;
  color: #474A4D;
  margin-right: 0.2rem;
}`, "",{"version":3,"sources":["webpack://./src/pages/Receipt/receipt.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,4DAAA;AACJ;;AAGA;EACI,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,qDAAA;AAAJ;;AAIA;EACI,iBAAA;EACA,iBAAA;EACA,iBAAA;AADJ;;AAIA;EACI,YAAA;EACA,8BAAA;EACA,WAAA;EACA,sBAAA;EACA,WAAA;EACA,UAAA;AADJ;;AAIA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;AADJ;AAGI;EACI,iBAAA;AADR;AAGI;EACI,mBAAA;EACA,iBAAA;AADR;;AAKA;EACI,2HAAA;EAEA,gCAAA;EACA,2BAAA;EACA,qBAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;AAHJ;;AAMA;EACI,iBAAA;EACA,cAAA;EACA,oBAAA;AAHJ","sourcesContent":[".mainContainer {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 100%;\n    width: 100%;\n    padding: 1rem;\n    background: linear-gradient(to bottom, transparent, #ebebec );\n\n}\n\n.styledReceipt {\n    background-color: #fff;\n    width: 22rem;\n    position: relative;\n    padding: 1rem;\n    text-align: center;\n    box-shadow: 0 -0.4rem 1rem -0.4rem rgba(0, 0, 0, 0.2);\n}\n\n\n.titleReceipt {\n    font-size: 1.1rem;\n    font-weight: bold;\n    padding: 0.5rem 0;\n}\n\n.hr {\n    border: none;\n    border-top: 1px dotted #005B96;\n    color: #fff;\n    background-color: #fff;\n    height: 1px;\n    width: 95%;\n}\n\n.rowReceipt {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0.5rem;\n\n    > :first-child {\n        font-size: 0.8rem;\n    }\n    > :last-child {\n        font-size: 0.875rem;\n        font-weight: bold;\n    }\n}\n\n.styledReceipt::after {\n    background-image: linear-gradient(135deg, #fff 0.5rem, transparent 0),\n    linear-gradient(-135deg, #fff 0.5rem, transparent 0);\n    background-position: left bottom;\n    background-repeat: repeat-x;\n    background-size: 1rem;\n    content: '';\n    display: block;\n    position: absolute;\n    bottom: -1rem;\n    left: 0;\n    width: 100%;\n    height: 1rem;\n}\n\n.unit {\n    font-size: 0.5rem;\n    color: #474A4D;\n    margin-right: 0.2rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
